import axios from "axios";

const apiUrl = import.meta.env.VITE_API_URL + "stocks";

export const dynamic = "force-dynamic";

export class StockService {
  // Token handled by cookie

  // add a new stock
  async addStock(stock) {
    try {
      const res = await axios.post(`${apiUrl}`, stock, { withCredentials: true });
      const data = res.data;

      if (!data.success) {
        throw new Error(data.message || "Failed to add stock");
      }

      return data;
    } catch (error) {
      throw error;
    }
  }

  // get all stocks
  async getStocks(params = {}) {
    try {
      const res = await axios.get(`${apiUrl}`, {
        params, // Pass query params (page, limit, search, sort...)
        withCredentials: true
      });
      const data = res.data;

      if (!data.success) {
        throw new Error(data.message || "Failed to get stocks");
      }
      return data;
    } catch (error) {
      throw error;
    }
  }

  // get a single stock by ID
  async getStock(id) {
    try {
      const res = await axios.get(`${apiUrl}/${id}`, { withCredentials: true });
      const data = res.data;

      if (!data.success) {
        throw new Error(data.message || "Failed to get stock");
      }

      return data;
    } catch (error) {
      throw error;
    }
  }

  // update a stock
  async updateStock({ id, ...rest }) {
    try {
      const res = await axios.put(`${apiUrl}/${id}`, rest, { withCredentials: true });
      const data = res.data;

      if (!data.success) {
        throw new Error(data.message || "Failed to update stock");
      }

      return data;
    } catch (error) {
      throw error;
    }
  }

  // delete a stock
  async deleteStock(id) {
    try {
      const res = await axios.delete(`${apiUrl}/${id}`, { withCredentials: true });
      const data = res.data;

      if (!data.success) {
        throw new Error(data.message || "Failed to delete stock");
      }

      return data;
    } catch (error) {
      throw error;
    }
  }

  // get low stock items
  async getLowStockItems() {
    try {
      const res = await axios.get(`${apiUrl}/low`, { withCredentials: true });
      const data = res.data;

      if (!data.success) {
        throw new Error(data.message || "Failed to get low stock items");
      }

      return data;
    } catch (error) {
      throw error;
    }
  }

  // get stock history with pagination
  async getStockHistory(id, page = 1, limit = 50) {
    try {
      const res = await axios.get(`${apiUrl}/${id}/history`, {
        params: { page, limit },
        withCredentials: true
      });
      const data = res.data;

      if (!data.success) {
        throw new Error(data.message || "Failed to get stock history");
      }

      return data;
    } catch (error) {
      throw error;
    }
  }

  // adjust stock quantity
  async adjustStockQuantity(id, adjustData) {
    try {
      const res = await axios.patch(`${apiUrl}/${id}/adjust`, adjustData, { withCredentials: true });
      const data = res.data;

      if (!data.success) {
        throw new Error(data.message || "Failed to adjust stock");
      }

      return data;
    } catch (error) {
      throw error;
    }
  }
}

